export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const checkLat = lat => {
  if (/^[-+]?[0-9.]+$/.test(lat))
    try {
      const num = Number.parseFloat(lat);
      return num >= -90 && num <= 90;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  else return false;
};
export const checkLng = lng => {
  if (/^[-+]?[0-9.]+$/.test(lng))
    try {
      const num = Number.parseFloat(lng);
      return num >= -180 && num <= 180;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  else return false;
};

export function checkPlz(value, country) {
  if (!value) return "Das Feld darf nicht leer sein";
  else if (value && !country) {
    if (!/^[0-9]{4,5}$/.test(value)) return "Postleitzahl ungültig";
    else return true;
  }
  switch (country) {
    case "Deutschland":
      return /^[0-9]{5}$/.test(value);
    case "Österreich":
    case "Schweiz":
      return /^[0-9]{4}$/.test(value);
    default:
      return "Postleitzahl ungültig";
  }
}

export const mapOptionDialogConfig = {
  header: ["Name", "Längengrad", "Breitengrad"],
  content: ["displayName", "lng", "lat"],
  key: "osmId"
};

export function validateUrl(str) {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
}
export const snowTextureItems = [
  { id: "oldSnow", title: "Altschnee" },
  { id: "solidOldSnow", title: "Fester Altschnee" },
  { id: "moistOldSnow", title: "Feuchtnasser Altschnee" },
  { id: "powderSnow", title: "Pulverschnee" },
  { id: "mashSnow", title: "Sulzschnee" },
  { id: "cardBoardSnow", title: "Pappschnee" },
  { id: "maschineSnow", title: "Maschinenschnee" },
  { id: "drySnow", title: "Trockener Neuschnee" },
  { id: "boundFreshSnow", title: "Gebundener Neuschnee" },
  { id: "frozenSnow", title: "Harsch" },
  { id: "firnSnow", title: "Firnschnee" }
];

export const stateItems = [
  { id: "", title: "Keine Angabe" },
  { id: "open", title: "Geöffnet" },
  { id: "closed", title: "Geschlossen" },
  { id: "openingHours", title: "Gemäß Öffnungszeiten" }
];
export const stateItemsAll = [
  { id: "", title: "Keine Angabe" },
  { id: "open", title: "Geöffnet" },
  { id: "closed", title: "Geschlossen" },
  { id: "openingHours", title: "Gemäß Öffnungszeiten" },
  { id: "highWorkload", title: "Aktuell hohe Auslastung" },
  { id: "capacityExhausted", title: "Belegt/Kapazität erschöpft" },
  { id: "seasonEnd", title: "Ende der Saison" },
  { id: "partiallyOpen", title: "Teilweise begehbar" },
  { id: "avalancheLock", title: "Lawinensperrung" }
];
